import { Ability, AbilityBuilder } from "@casl/ability";
import { store } from "../store/store";

const ability = new Ability();

export default (action, subject) => {
    return ability.can(action, subject);
};

store.subscribe(() => {
    let auth = store.getState().auth;
    let permissions = store.getState().authPermissions;
    ability.update(defineRulesFor(auth, permissions));
});

const defineRulesFor = (auth, permissions) => {

    const rol = auth.typeUser;
    const userPermissions = permissions.permissions;
    const { can, rules } = new AbilityBuilder();

    if (rol && userPermissions) {
        userPermissions.forEach((p) => {
            can(p.action, p.element);
        });
    }

    return rules;
};